import cx from "classnames";
import React from "react";
import Search from "../../../../../../EventsScreen/components/EventsScreenHeader/components/Search/Search";

type Props = {
  onClickSearchActive: (...args: Array<any>) => any;
  bookmarksOnly: boolean;
  favouritesOnly: boolean;
  stopCompetitionsPolling: (...args: Array<any>) => any;
  selectLeagues: (...args: Array<any>) => any;
  searchActive: boolean;
};

const SearchEventsAndLeagues: React.FC<Props> = ({
  onClickSearchActive,
  bookmarksOnly,
  favouritesOnly,
  stopCompetitionsPolling,
  selectLeagues,
  searchActive,
}) => {
  return (
    <div
      className={`search-events-and-leagues ${
        favouritesOnly || bookmarksOnly ? "hide" : ""
      }`}
    >
      <div
        className={cx("search-events-and-leagues__type", {
          "search-events-and-leagues__type--search-active": searchActive,
        })}
      />
      <span
        className={cx("search-events-and-leagues__search", {
          "search-events-and-leagues__search--active": searchActive,
        })}
      >
        <div
          onClick={onClickSearchActive}
          className="search-events-and-leagues__search__click-box"
        />
        <Search
          stopCompetitionsPolling={stopCompetitionsPolling}
          selectLeagues={selectLeagues.bind(this)}
        />
      </span>
    </div>
  );
};

export default SearchEventsAndLeagues;
